/**
 * Defines the different statuses for registration availability checking for a user.
 */
export enum RegistrationChecksStatus {
  RegistrationNotAllowed = 'RegistrationNotAllowed',
  RegistrationAllowed = 'RegistrationAllowed',
  IdentityEmailMismatch = 'IdentityEmailMismatch'
}
